var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaceGood = function SvgFaceGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.29,
    cy: 16,
    r: 16,
    fill: "#1F9974"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.936 13.47a1.386 1.386 0 0 1-.363-.934c0-.784.66-1.42 1.476-1.42.58 0 1.081.322 1.323.79a1.482 1.482 0 0 1 1.323-.79c.814 0 1.475.636 1.475 1.42 0 .357-.137.684-.362.933l-1.65 2.1a1 1 0 0 1-1.573 0l-1.649-2.099ZM7.773 13.47a1.386 1.386 0 0 1-.363-.934c0-.784.66-1.42 1.476-1.42.58 0 1.081.322 1.323.79a1.482 1.482 0 0 1 1.322-.79c.815 0 1.476.636 1.476 1.42 0 .357-.137.684-.362.933l-1.65 2.1a1 1 0 0 1-1.573 0L7.773 13.47Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.573 19.814c0 2.132-1.47 3.86-3.283 3.86s-3.283-1.728-3.283-3.86",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFaceGood;